import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { CONTROLLERS, ENDPOINTS } from '../../constants';
import {
  Response,
  Token,
  TokenPreference,
  UpdateBillingAddress,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private api: string = CONTROLLERS.PAYMENTS.TOKEN;
  constructor(private apiService: ApiService) {}

  getCardTokensByPatientId(
    practiceId: number,
    patientId: number
  ): Observable<Response<Token[]>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PAYMENTS.TOKEN.GET_CARD_TOKENS_BY_PATIENTS}`,
      {
        practiceId,
        patientId,
      }
    );
  }

  getCardTokensByPracticeId(
    practiceId: number
  ): Observable<Response<Token[]>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PAYMENTS.TOKEN.GET_CARD_TOKENS_BY_PRACTICE}`,
      {
        practiceId,
      }
    );
  }

  updateTokenPreference(body: TokenPreference): Observable<Response<any>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.PAYMENTS.PAYMENT.UPDATE_TOKEN_PREFERENCES}`,
      body
    );
  }

  updateTokenBillingAddress(
    body: UpdateBillingAddress
  ): Observable<Response<any>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.PAYMENTS.PAYMENT.UPDATE_TOKEN_BILLING_ADDRESS}`,
      body
    );
  }
}
